import { logger } from '@/services/logger'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getCompanyOrdersByCompanyId } from '@/services/companyOrders'
import type { CompanyOrderType } from '@/types/companyOrders.types'
import { useEmployeeStore } from '@/stores/employee'

export const useCompanyOrdersStore = defineStore('company-orders', () => {
  const companyOrders = ref<CompanyOrderType[]>([])
  const getCompanyOrdersPendingPromise = ref<Promise<void> | null>(null)

  const getCompanyOrders = async () => {
    if (getCompanyOrdersPendingPromise.value) {
      await getCompanyOrdersPendingPromise.value

      return
    }

    const promise = executeGetCompanyOrders()
    getCompanyOrdersPendingPromise.value = promise
    await promise
  }

  const executeGetCompanyOrders = async () => {
    const employeeStore = useEmployeeStore()

    try {
      if (!employeeStore.employee) {
        await employeeStore.setEmployee()
      }

      if (!employeeStore.employee?.companyId) throw new Error('Company ID not found')

      const response = await getCompanyOrdersByCompanyId(employeeStore.employee.companyId)

      if (!response.data || response.status !== 200) {
        throw new Error('Failed to get company orders')
      }

      companyOrders.value = response.data.orders
    } catch (error) {
      logger.error(error)

      throw error
    } finally {
      getCompanyOrdersPendingPromise.value = null
    }
  }

  return {
    companyOrders,
    getCompanyOrders
  }
})
